import { useRef } from 'react';

import MaskedNumberInput, { MaskedNumberInputProps } from 'components/masked-number-input';

import { toReadablePrice } from 'lib/utils';
import { numberWithNounMask } from 'lib/input-masks';

type DayInputProps = MaskedNumberInputProps;

const DayInput: React.FC<DayInputProps> = (props) => {
  const { min = 1, max = 40, ...rest } = props;

  const maskOpts = useRef(numberWithNounMask('день', 'дней', 'дня', { min, max }));

  return (
    <MaskedNumberInput
      min={min}
      max={max}
      format={toReadablePrice}
      maskOpts={maskOpts.current}
      {...rest}
    />
  );
};

export default DayInput;
